import { GuardianService } from './../../_services/guardian.service';
import { Component, Input, OnInit } from '@angular/core';
import { Guardian } from 'src/app/_models/guardian';

@Component({
  selector: 'app-study-material-guardian',
  templateUrl: './study-material-guardian.component.html',
  styleUrls: ['./study-material-guardian.component.css']
})
export class StudyMaterialGuardianComponent implements OnInit {
  guardian = new Guardian()
  @Input() server_user_id=0
  loading=false
  constructor(
    private guardianService: GuardianService) {

  }
  ngOnInit(): void {
    this.loading=true
       if (this.server_user_id!=0) {
        this.guardianService.getByUserId(this.server_user_id).subscribe(
          x => {
            this.guardian = x
            this.loading=false
          })
      }
   
  }
}
